<template>
	<div class="view-wrapper">
		<div 	class="view-container"
				v-if="provider !== null && error == null">
			<b-container class="no-padding">
				<b-row>
					<b-col 	md="4"
							sm="12"
							class="text-center">
						<b-img v-bind:src="provider.brandImage.secure_url" fluid alt="Logo" />
						<div class="space30"></div>							
					</b-col>
					<b-col 	md="8"
							sm="12">
						<p><h3 class="vrnu-headline">{{ provider.name }}</h3></p>
						<b-container class="no-padding">
							<b-row>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Adresse</h4>
									<span>{{ provider.street }} {{ provider.houseNumber }}</span>
									<br>
									<span>{{ provider.zip }} {{ provider.city }}</span>		
									<div class="space30"></div>							
								</b-col>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Geokoordinaten</h4>
									<span>Längengrad: {{ provider.lat }}</span>
									<br>
									<span>Breitengrad: {{ provider.lon }}</span>
									<div class="space30"></div>
								</b-col>
							</b-row>
							<b-row>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Aktiv</h4>
									<span v-if="provider.active">
										<span class="icon-check text-green"></span> Der Anbieter ist aktiv und wird in der App angezeigt
									</span>
									<span v-else>
										<span class="icon-cancel text-red"></span> Der Anbieter ist nicht aktiv und wird in der App nicht angezeigt
									</span>
									<div class="space30"></div>
								</b-col>
								<b-col 	lg="6"
										md="12">
									<h4 class="text-underlined">Kategorie</h4>
									<span>{{ options[provider.category] }}</span>
									<div class="space30"></div>
								</b-col>
							</b-row>
						</b-container>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<div v-else>
			<b-alert show variant="danger">{{ error }}</b-alert>
		</div>
	</div>
</template>

<script>
export default {
	data: function() {
		return {
			provider: null,
			error: null,
			options: {
				leisure: 'Freizeit',
				sports: 'Sport',
				shops: 'Shopping',
				season: 'Saisonales',
				food: 'Essen & Getränke', 	
			},
		};
	},
	computed: {
		adress: function() {
			return {
				street: this.provider.street,
				houseNumber: this.provider.houseNumber,
				city: this.provider.city,
				zip: this.provider.zip,
			};
		},
	},
	methods: {
		getProvider: function() {
			// Save the provider
			this.$http.get('providers/' + this.objectId).then(result => {
				this.provider = result.body;
			}, response => {
				this.error = "Beim Laden des Anbieters ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Systemadministrator!";
			});
		},
		closeModal: function() {
			this.$emit('closeModal');
		},
	},
	mounted: function() {
		// Load provider from database
		this.getProvider();
	},
	props: {
		objectId: {
			required: true,
		}
	},
}
</script>

<style>
.form-container {
	padding: 5px;
}
.text-underlined {
	text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/03_provider/ProvidersView.vue